import { EcommerceSales } from "../features/e-commerce/pages/e-comm-sales"
import { DashboardLayout } from "../layouts/DashboardLayout"

export default function ECommerceSalesPage() {
  return (
    <DashboardLayout>
      <EcommerceSales />
    </DashboardLayout>
  )
}
